import React, { Component } from 'react';
import { compose } from 'redux';
import { Iframe } from './styled';

class DynamicIframe extends Component {
	render() {
		const { url, title, height } = this.props;
		return (
			<Iframe
				id={url}
				ref={'DynamicIframe'}
				src={url}
				title={title}
				width="100%"
				frameBorder="0"
				style={height ? { height } : undefined}
			/>
		);
	}
}

export default compose()(DynamicIframe);
